<template>
  <Teleport to="body">
    <div v-if="visible" class="deposit-notification-overlay" @click="close">
      <div class="deposit-notification-modal" @click.stop>
        <div class="notification-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="32" fill="#22c55e" opacity="0.1"/>
            <path d="M32 8C18.745 8 8 18.745 8 32C8 45.255 18.745 56 32 56C45.255 56 56 45.255 56 32C56 18.745 45.255 8 32 8ZM28 42L18 32L20.82 29.18L28 36.34L43.18 21.18L46 24L28 42Z" fill="#22c55e"/>
          </svg>
        </div>
        <h2 class="notification-title">Deposit Received!</h2>
        <p class="notification-amount">+{{ formatAmount(amount) }} USDT</p>
        <p class="notification-text">Transaction confirmed</p>
        <button class="notification-button" @click="close">OK</button>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { ref, watch } from 'vue'

export default {
  name: 'DepositNotification',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    amount: {
      type: Number,
      default: 0
    }
  },
  emits: ['close'],
  setup(props, { emit }) {
    const visible = ref(false)

    watch(() => props.show, (newVal) => {
      visible.value = newVal
    })

    const formatAmount = (value) => {
      if (value == null || isNaN(value)) return '0.00'
      return Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }

    const close = () => {
      visible.value = false
      emit('close')
    }

    return {
      visible,
      formatAmount,
      close
    }
  }
}
</script>

<style scoped>
.deposit-notification-overlay {
  font-family: var(--font-family-base, sans-serif);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: var(--spacing-lg, 16px);
  animation: fadeIn 0.2s ease;
}

.deposit-notification-modal {
  background: var(--color-bg-secondary, #1e1e2e);
  border-radius: var(--radius-lg, 16px);
  padding: 32px 24px;
  max-width: 340px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  animation: slideUp 0.3s ease;
  border: 1px solid rgba(34, 197, 94, 0.2);
}

.notification-icon {
  margin-bottom: 8px;
}

.notification-title {
  font-size: 20px;
  font-weight: 700;
  color: #22c55e;
  margin: 0;
}

.notification-amount {
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text-primary, #fff);
  margin: 0;
}

.notification-text {
  font-size: 14px;
  color: var(--color-text-secondary, #888);
  margin: 0;
}

.notification-button {
  margin-top: 8px;
  padding: 12px 48px;
  background: #22c55e;
  color: #fff;
  border: none;
  border-radius: var(--radius-md, 12px);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.notification-button:hover {
  background: #1ea34b;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
</style>
